"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
var akita_1 = require("@datorama/akita");
__exportStar(require("./feature"), exports);
__exportStar(require("./core"), exports);
console.log('ENV:');
console.log(window.QW_HOTEL_ENV);
akita_1.akitaDevtools();
// GET SESSION AND ROOMS
// SessionService.getSession().pipe(
//   switchMap((session: SessionModel) => {
//     return zip(of(session), RoomService.getRooms(session.sessionId));
//   }),
// ).subscribe(([session, roomsArray]) => {
//   this.rooms = roomsArray;
//   this.session = session;
//   console.log('session', session, roomsArray);
// });
// GET SESSION AND EXTRA
// SessionService.getSession().pipe(
//   switchMap((session: SessionModel) => {
//     return zip(of(session), ExtraService.getExtra(session.sessionId));
//   })
// ).subscribe(([session, extra]) => {
//   this.session = session;
//   console.log('session extra', extra.hotelExtras, extra.roomExtras);
// });
//
//
//
//
// ExtraLoaded$.subscribe(extra => {
//   this.extra = extra;
// });
/*setTimeout(() => {
  console.log('timeout');
  SessionService.getSession().subscribe(console.log);}, 3000);
SessionLoaded$.pipe(
  switchMap((session) => {
    console.log('session loaded');
    return RoomService.getRoomPricesForStayPeriods([
      {arrivalDate: '2020-03-26', departureDate: '2020-03-27'},
      {arrivalDate: '2020-03-27', departureDate: '2020-03-28'}], 'JPY');
  })
).subscribe((res) => console.log(res));
SessionLoaded$.pipe(
  switchMap((session) => {
    console.log('session loaded');
    return RoomService.getRoomsAvailability(session.sessionId);
  })
).subscribe((res) => console.log(res));*/
// if (!fetchGetSession$) {
//   fetchGetSession$ = Http.get<any>(SessionApi.get(sessionId), options).pipe(
//     share(),
//     map((res) => createSession(res)),
//   );
// }
//
// return fetchGetSession$;
// let basketInstance: Observable<BasketModel>;
// const getBasket = (session) => {
//   if (!basketInstance) {
//     basketInstance = BasketService.getBasket(session);
//   }
// };
// const clearCacheBasket = () => basketInstance = null;
// SessionLoaded$.pipe(
//   map((session) => {
//     getBasket(session);
//     console.log(session);
//     return basketInstance;
//   }),
// ).subscribe();
//
// // ADD ROOM AND SEE BASKET CHANGES
// document.addEventListener('DOMContentLoaded', () => {
//   const addRoomBtn = document.querySelector('button');
//   const addRoomBtn2 = document.querySelector('button.two');
//   const changeContextDiv = document.querySelector('.change-context');
//   addRoomBtn.addEventListener('click', () => {
//     console.log('added Room');
//     BasketService.setRoomInBasket({
//       roomId: 86549,
//       rateId: '20210707;20210708;326402',
//       occupancyId: 0,
//       quantity: 1,
//     }).pipe(
//       switchMap(res => SessionService.getSession()),
//       switchMap((session: SessionModel) => BasketService.getBasket(session)),
//     ).subscribe((basket: BasketModel) => {
//       const numeroDiStanze = BasketHelper.getNumberOfAccommodation(basket);
//       const occupancyPerStanza = BasketHelper.getOccupancyOfAccommodation(basket);
//       // console.log('selectedQuantity e occupancy: ', numeroDiStanze, occupancyPerStanza);
//     });
//   });
// addRoomBtn2.addEventListener('click', () => {
//   console.log('added EXTRA');
//   BasketService.setExtraInBasket({
//     quantity: 1,
//     roomId: 86549,
//     extraId: 88461,
//   }).pipe(first()).subscribe();
// });
//   changeContextDiv.addEventListener('click', () => {
//     console.log('click');
//     SessionService.updateContextSession({
//       stayPeriod: {arrivalDate: '2021-07-07', departureDate: '2021-07-08'},
//       guests: {
//         adults: 1,
//         children: 1,
//         infants: 0,
//       },
//       selectedHotelId: 21183,
//       excludeMixedRates: false,
//       disableCrossSell: false,
//     }).subscribe();
//   });
// });
//# sourceMappingURL=index.js.map